var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11096",
    "data-name": "Gruppe 11096",
    transform: "translate(16 16) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9506",
    "data-name": "Rechteck 9506",
    width: 16,
    height: 16,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7589",
    "data-name": "Pfad 7589",
    d: "M15108-17574.494l6.666,6,6.668-6",
    transform: "translate(-15106.669 17579.66)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upArrow.22d503164787e4a2bcec3218421d9664.svg";